import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import { FormControl } from '@mui/material';

function Step4({ answers }) {
  const classes = useStyles();

  return (
    <div className={classes.stepContainer}>
      <h4>{answers.title}</h4>
      {answers.listing_location_display}
      {answers.use_suggested_classification ? (
        <div>
          {answers.listing_location_display} <span style={{ margin: '0 1rem' }}>&gt;</span>{' '}
          {answers.listing_sub_classification_display}
        </div>
      ) : (
        <div>{answers.listing_sub_classification_display}</div>
      )}
      <FormControl
        fullWidth={true}
        style={{ margin: '0.5rem 0 1.5rem 0' }}
        className={`preview-html ${classes.formControl} ${classes.large}`}
      >
        <div dangerouslySetInnerHTML={{ __html: answers.ad_details }} />
      </FormControl>
    </div>
  );
}

Step4.propTypes = {
  answers: PropTypes.object
};

export default Step4;
